import { render, staticRenderFns } from "./registerZJ.vue?vue&type=template&id=3b370225&scoped=true"
import script from "./registerZJ.vue?vue&type=script&lang=js"
export * from "./registerZJ.vue?vue&type=script&lang=js"
import style0 from "./registerZJ.vue?vue&type=style&index=0&id=3b370225&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b370225",
  null
  
)

export default component.exports